import classnames from 'classnames';
const bindOwnClassnamesWithSkin = (ownClassMapping, skinClassMapping)=>{
    return (...classnamesList)=>{
        const ownClassnames = classnamesList.map((classname)=>ownClassMapping[classname]);
        const skinClassnames = classnamesList.map((classname)=>skinClassMapping[classname]);
        return classnames(...ownClassnames, ...skinClassnames);
    };
};
export default bindOwnClassnamesWithSkin;
